import type { AxiosInstance } from "axios";
import { LOGIN_API_URL } from "~/env";
import { sendRequest } from "~/utils/axios-utils";

const url = {
  getTokenV2: "/api/v2/platform/access/parseTokenV2", // 第三方接入解析tokenV2
  checkVip: "/api/v2/platform/access/checkLicenseIsReceive", // 检查是否已经领取会员V2
  receiveVip: "/api/v2/platform/access/receiveLicense", // 手动领取会员V2
  getOrderList: "/api/v2/platform/access/getOtherPlatformPayOrderPageList", // 深i企订单列表
  getOrderDetail: "/api/v2/platform/access/getPayOrderDetail", // 深i企订单详情
};

export default ($axios: AxiosInstance) => {
  $axios.defaults.baseURL = LOGIN_API_URL;

  return {
    // 第三方接入解析tokenV2
    getTokenV2: (params: API.GetTokenV2Params) =>
      sendRequest<API.GetTokenV2Result>($axios, {
        headers: {
          "Access-Appid": "data_siq",
        },
        method: "POST",
        url: url.getTokenV2,
        data: params,
      }),

    // 检查是否已经领取会员V2
    checkVip: (params: API.CheckVipParams) =>
      sendRequest<API.CheckVipResult>($axios, {
        method: "POST",
        url: url.checkVip,
        data: params,
      }),

    // 手动领取会员V2
    receiveVip: (params: API.ReceiveVipParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.receiveVip,
        data: params,
      }),

    // 深i企订单列表
    getOrderList: (params: API.GetOrderListParams) =>
      sendRequest<API.GetOrderListResult>($axios, {
        method: "POST",
        url: url.getOrderList,
        data: params,
      }),

    // 订单详情
    getOrderDetail: (params: API.GetOrderDetailParams) =>
      sendRequest<API.GetOrderDetailResult>($axios, {
        method: "GET",
        url: url.getOrderDetail,
        data: params,
      }),
    /**
     * 文件上传（滑块验证）
     */
    sendSmsCaptcha: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v1/accounts/send_sms_captcha_v2",
        data: params,
      }),
    /**
     * 上海律协app解析token
     */
    parseToken: (params: any) =>
      sendRequest($axios, {
        headers: {
          "Access-Appid": params.appId ?? params.appid,
        },
        method: "POST",
        url: "/api/v1/otherPlatformAccess/parseToken",
        data: params,
      }),

    /**
     * 获取token
     */
    getTokenInfo: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/accounts/token_info",
        params,
      }),

    /**
     * 上海律协app校验是否赠送过会员
     */
    checkLicenseIsReceive: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v1/otherPlatformAccess/checkLicenseIsReceive",
        data: params,
      }),
    /**
     * 获取法搜小程序jssdk后台签名接口
     */
    getFSWXCofinfig: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/deli_applet_user/getWXConfig",
        params,
      }),
    /**
     * 深i企赠送会员/api/v1/siqPlatformAccess/receiveLicense
     */
    receiveLicense: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/receiveLicense",
        data: params,
      }),
    /**
     * 检查深i企是否赠送过会员
     */
    checkPickVip: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/checkLicenseIsReceive",
        data: params,
      }),
    /**
     * 获取加密scheme码
     */
    getGenerateScheme: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v1/deli_applet_user/getGenerateScheme",
        data: params,
      }),
    /**
     * 获取siq用户信息
     */
    getPartyInfo: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/siqPlatformAccess/info",
      }),
    /**
     * 更新siq用户信息
     */
    updateUserInfo: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v1/siqPlatformAccess/updateUserInfo",
        data: params,
      }),
    // 获取第三方套餐V2
    getThirdPartyList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/getOtherAccessPlanList",
        data: params,
      }),
    /**
     * 深i企解析token
     */
    siqParseToken: (params: any, headers = {}) =>
      sendRequest($axios, {
        headers: {
          // "Access-Appid": params.appId ?? params.appid,
          ...headers,
        },
        method: "POST",
        url: "/api/v2/platform/access/parseTokenV2",
        data: params,
      }),
    /**
     * 深i企获取套餐
     */
    getOtherAccessPlanList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/getOtherAccessPlanList",
        data: params,
      }),
    /**
     * 深i企订单列表
     */
    getPayOrderPageList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/getOtherPlatformPayOrderPageList",
        data: params,
      }),
    /**
     *
     *  深i企订单详情/
     */
    getOrderInfo: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v2/platform/access/getPayOrderDetail",
        data: params,
      }),
  };
};
